const MIN_ERROR = 400
const MAX_ERROR = 600

export const isError = (code) => {
    return code >= MIN_ERROR && code < MAX_ERROR
  }
